import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const createOffsetService = (
  offsetObject: any
): Promise<AxiosResponse> => {
  const businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  offsetObject.businessUnit = businessUnit;

  return axiosAuth.post(API_PATH().apis.offset, offsetObject);
};

export const updateOffsetService = (
  offsetObject: any
): Promise<AxiosResponse> => {
  //const company = JSON.parse(localStorage.getItem("company") || "").id;
  const businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  offsetObject.businessUnit = businessUnit;

  return axiosAuth.put(API_PATH().apis.offset, offsetObject);
};

export const updateStatusOffsetService = (
  offsetObject: any
): Promise<AxiosResponse> => {
  const businessUnit =
    localStorage.getItem("currentBusinessUnit") &&
    JSON.parse(localStorage.getItem("currentBusinessUnit") || "{}").id;
  // offsetObject.businessUnit = businessUnit;
  // offsetObject.company = company;
  const userName = JSON.parse(
    localStorage.getItem("user") || "{}"
  )?.displayName;
  offsetObject.userName = userName;
  return axiosAuth.put(API_PATH().apis.offsetstatus, offsetObject);
};

export const getOffsetListService = (
  offsetObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit:
        localStorage.getItem("currentBusinessUnit") &&
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    },
  };
  config.params.page = (offsetObject.controller.page || 0) + 1;
  config.params.limit = offsetObject.controller.limit;
  config.params.searchText = offsetObject.searchText;
  if (offsetObject?.controller?.sortBy && offsetObject?.controller?.sortOrder) {
    config.params.sortBy = offsetObject?.controller?.sortBy;
    config.params.sortOrder = offsetObject?.controller?.sortOrder;
  }
  if (offsetObject?.filter?.types) {
    config.params.types = offsetObject?.filter?.types;
  }
  if (offsetObject?.filter?.program) {
    config.params.program = offsetObject?.filter?.program;
  }
  if (offsetObject?.filter?.statusFilter) {
    config.params.statusFilter = offsetObject?.filter?.statusFilter;
  }
  return axiosAuth.get(API_PATH().apis.offsets, config);
};

export const getSingleOffset = (offsetObject: any): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnit:
        localStorage.getItem("currentBusinessUnit") &&
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
      id: offsetObject.id,
    },
  };
  return axiosAuth.get(API_PATH().apis.offset, config);
};

export const getOffsetsByYear = (offsetObject: any): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {
      businessUnits: offsetObject?.businessUnits
        ? offsetObject?.businessUnits
        : localStorage.getItem("currentBusinessUnit") &&
          JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id,
    },
  };
  return axiosAuth.get(API_PATH().apis.offsetsByYear, config);
};

export const getOffsetsByMonth = (
  offsetObject: any
): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: offsetObject,
  };
  return axiosAuth.get(API_PATH().apis.offsetsByMonth, config);
};

export const createOffsetProgramService = (
  programDataObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.offsetprogram, programDataObject);
};

export const getOffsetProgramsService = (): Promise<AxiosResponse> => {
  let config: AxiosRequestConfig = {
    params: {},
  };
  return axiosAuth.get(API_PATH().apis.offsetprograms, config);
};
